import React, { useEffect } from 'react';
import { useFormikContext, Field, ErrorMessage } from 'formik';
import { FormControl, Grid, MenuItem, TextField } from '@mui/material';

const DependentChildrenFields = ({ maritalStatusList }) => {
    const {
        values,
        setFieldValue,
        handleBlur,
        touched,
        errors,
    } = useFormikContext();

    // Define children options
    const childrenOptionsAll = [
        { value: '0', label: 'None' },
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4 and above' }
    ];

    const childrenOptionsLimited = [
        { value: '0', label: 'None' }
    ];

    // Use correct option set based on living status
    const childrenOptions =
        values.childrenLivingStatus === 'Living with me'
            ? childrenOptionsAll
            : childrenOptionsLimited;

    // Reset children fields if maritalStatus is 1
    useEffect(() => {
        if (values.maritalStatus === '1') {
            setFieldValue('childrenLivingStatus', '');
            setFieldValue('no_of_Children', '');
        }
    }, [values.maritalStatus, setFieldValue]);

    // Reset number of children if childrenLivingStatus is empty
    useEffect(() => {
        if (!values.childrenLivingStatus) {
            setFieldValue('no_of_Children', '');
        }
    }, [values.childrenLivingStatus, setFieldValue]);

    return (
        <>
            {/* Marital Status */}
            <Grid item md={4} >
                <label className="form-label">Marital Status</label>
                <Field
                    as={TextField}
                    select
                    fullWidth
                    size="small"
                    name="maritalStatus"
                    label="Marital Status"
                    sx={{ backgroundColor: 'white' }}
                >
                    <MenuItem value="">Please Select</MenuItem>
                    {maritalStatusList
                        .filter(item => item.id !== 7) // skip 'Not applicable' or other
                        .map(item => (
                            <MenuItem key={item.id} value={String(item.id)}>
                                {item.status}
                            </MenuItem>
                        ))}
                </Field>
                <ErrorMessage name="maritalStatus" component="div" className="text-danger" />
            </Grid>

            {/* Children Living Status - shown only if maritalStatus !== 1 */}
            {values.maritalStatus && values.maritalStatus !== '1' && (
                <Grid item md={4}>
                     <label className='form-label' htmlFor="">Children Living Status</label>
                    <FormControl fullWidth size='small' variant="outlined" margin="none">
                    <Field
                        as={TextField}
                        select
                        fullWidth
                        size="small"
                        name="childrenLivingStatus"
                        label="Children Living Status"
                        onBlur={handleBlur}
                        sx={{ backgroundColor: 'white' }}
                    >
                        <MenuItem value="">Select an option</MenuItem>
                        <MenuItem value="Living with me">Living with me</MenuItem>
                        <MenuItem value="Not Living with me">Not Living with me</MenuItem>
                    </Field>
                    <ErrorMessage name="childrenLivingStatus" component="div" className="text-danger" />
                </FormControl>
                </Grid>
            )}

            {/* Number of Children - shown only if childrenLivingStatus is selected */}
            {values.maritalStatus !== '1' && values.childrenLivingStatus && (

                <Grid item md={4}>
                    <label className='form-label' htmlFor="">Number of Children</label>
                    <Field
                        as={TextField}
                        select
                        fullWidth
                        size="small"
                        name="no_of_Children"
                        label="Number of Children"
                        onBlur={handleBlur}
                        sx={{ backgroundColor: 'white' }}
                    >
                        <MenuItem value="">Select an option</MenuItem>
                        {childrenOptions.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Field>
                    <ErrorMessage name="no_of_Children" component="div" className="text-danger" />
                </Grid>
            )}
        </>
    );
};

export default DependentChildrenFields;
